import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { useAuth } from '../../components/auth/useAuth'
import { useTranslation } from 'react-i18next'
import CabeceraMovil from '../../components/menus/CabeceraMovil'

export default function NothingHere () {
    const { t } = useTranslation()
	const {clientauth} = useAuth()

	return (
		<>
			<Container className='contenido' style={clientauth ? {} : {marginTop: 0}} >
				<Row className='d-none d-md-block'>
					<Col xs={12}>
						<h1 className='text-center'>{t('global.error')}</h1>
					</Col>
				</Row>
				<Row>
					<Col className='text-center my-5'>
						<h2 className='text-center'>{t('global.error404')}</h2>
						<p>{t('global.error404description')}</p>
					</Col>
				</Row>
			</Container>
		</>
	)
}